module.exports = __webpack_public_path__ + "static/media/IMG_4.1cd42cce.jpg";